import { CTAProps } from './types';
import Button from 'components/shared/Buttons/BaseButton';
import { Cta } from 'libs/contentful/types';

const CTA = ({ cta, ctaLevel, variant, className, id, testId }: CTAProps) => {
  const buttonVariant = variant || cta?.variant;
  const internalPage = cta?.internalPage?.slug ? cta.internalPage : undefined;

  return (
    <Button
      sys={cta?.sys}
      href={cta?.url}
      internalPage={internalPage}
      target={cta?.target}
      ctaLevel={ctaLevel}
      variant={buttonVariant}
      className={className}
      id={id}
      testId={testId}>
      {cta?.text}
    </Button>
  );
};

export const isValidCta = (cta?: Cta): cta is Cta => {
  return Boolean((cta?.url || cta?.internalPage?.slug) && cta?.text);
};

export default CTA;
